import { Injectable } from '@angular/core';
import { PagePdfAccessibilityRepoService } from '@client/app/services/api/page-pdf-accessibility/page-pdf-accessibility-repo.service';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import {
    DemoPagePdfAccessibilityRepoService,
} from '@client/app/modules/demodata/endpoints/pages/demo-page-pdf-accessibility-repo/demo-page-pdf-accessibility-repo.service';


@Injectable({
    providedIn: 'root',
})
export class PagePdfAccessibilityService {
    constructor (
        private pagePdfAccessibilityRepoService: PagePdfAccessibilityRepoService,
        private demoHasAccessService: DemoHasAccessService,
        private demoPagePdfAccessibilityRepoService: DemoPagePdfAccessibilityRepoService,
    ) {}

    /**
   * Get Checks collection for a single PDF document
   * @param documentId - The document id
   * @param params - The parameters to inject to the get request
   * @returns Promise containing checks collection
   */
    getAllChecks (documentId: number, params: any) {
        if (this.demoHasAccessService.canAccessAccessibilityPDF()) {
            return this.demoPagePdfAccessibilityRepoService.getAllChecks(documentId);
        }
        return this.pagePdfAccessibilityRepoService.getAllChecks(documentId);
    }

    /**
   * Get Errors collection of a single Accessibility Check
   * @param documentId - The document id
   * @param checkId - The Accessibility Check ID
   * @param params - The parameters to inject to the get request
   * @returns Promise containing the error collection
   */
    getCheckErrors (documentId: number, checkId: number, params: any) {
        if (this.demoHasAccessService.canAccessAccessibilityPDF()) {
            return this.demoPagePdfAccessibilityRepoService.getCheckErrors(documentId, checkId);
        }
        return this.pagePdfAccessibilityRepoService.getCheckErrors(documentId, checkId, params);
    }

    /**
   * Update the error of an Accessibility Check
   * @param pageId - The page id
   * @param checkId - The Accessibility check id
   * @param errorId - The ID of the error in the database
   * @param data - The data object to add to the request
   * @param params - The query parameters
   * @returns Promise containing the updated error
   */
    updateCheckError (pageId: number, checkId: number, errorId: number, data: Record<string, unknown>, params: any) {
        if (this.demoHasAccessService.canAccessAccessibilityPDF()) {
            return this.demoPagePdfAccessibilityRepoService.updateCheckError(params);
        }
        return this.pagePdfAccessibilityRepoService.updateCheckError(pageId, checkId, errorId, params);
    }
}
